<div role="dialog" aria-labelledby="modalAddScheduleMessage" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalAddScheduleMessage">
          {{ 'attendance.chatSchedule.addScheduledMessage' | translate }}
          <br>
          <span class="text-muted fw-normal font-14">{{ 'attendance.chatSchedule.fillDataToScheduleMessage' | translate }}</span>
        </h4>
        <button type="button" class="btn-close" [mat-dialog-close]="true" aria-hidden="true"></button>
      </div>
      <div class="modal-body custom-scroll-bar">
        <input id="tab-one" type="radio" name="tabs" class="peer/tab-one opacity-0 absolute" checked />
        <form [formGroup]="form">
          <div class="textarea-wrapper">
            
            @if(data.attendance.channel.type === 'Z_API') {
              <div class="col-6 mb-3">
                <label class="form-label">{{ 'attendance.chatSchedule.responseType' | translate }} *</label>
                <select class="form-select" formControlName="typeResponse">
                  @for (option of responseTypes; track option) {
                  <option [value]="option.value">{{ option.label }}</option>
                  }
                </select>
              </div>
            }
            <div class="row pb-4">
              <div class="col-6">
                <label class="form-label">{{ 'attendance.chatSchedule.date' | translate }} *</label>
                <div
                  id="input-phone"
                  class="trend-datepicker"
                >
                  <input
                    readonly
                    [matDatepicker]="picker"
                    formControlName="scheduledDay"
                    [placeholder]="'attendance.chatSchedule.selectDate' | translate"
                    class="form-control"
                    (focus)="picker.open()"
                  />
                  <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                  <mat-datepicker #picker></mat-datepicker>
                </div>
                <field-error-component 
                  [field]="'scheduledDay'" 
                  [label]="'Data'" 
                  [formGroup]="form"
                />
              </div>
        
              <div class="col-6">
                <label class="form-label">{{ 'attendance.chatSchedule.time' | translate }} *</label>
                <input
                  class="form-control"
                  formControlName="scheduledHour"
                  [placeholder]="'attendance.chatSchedule.timeExample' | translate"
                  mask="00:00">
                <small class="text-muted mt-1">{{ 'attendance.chatSchedule.validTimeFormat' | translate }}</small>
                @if(hourErrorMessage) {
                  <div class="text-danger mt-1">{{ hourErrorMessage }}</div>
                }
              </div>
            </div>

            @if (isTypeText()) {
              <div class="row">
                <div class="col-7 position-relative" [ngClass]="attachment && contentType?.includes('audio/') ? 'col-12 px-5' : ''">
                  @if(!shouldDisableTextarea() && !isLoading) {
                    <div class="position-relative">
                      <textarea
                        #messageTextarea
                        formControlName="message"
                        class="form-control my-2"
                        [placeholder]="'attendance.chatSchedule.messagePlaceholder' | translate"
                        [attr.disabled]="shouldDisableTextarea()"
                        rows="7">
                      </textarea>
  
                      @if(!isRecording && !audioUrl && !isLoading && !contentType?.includes('audio/')) {
                        <div class="d-flex position-absolute gap-2 left-0 top-0 mt-n4 px-2 pt-1">
                          <a href="javascript:void(0)" class="font-18 text-dark" (click)="applyFormat('bold')">
                            <i class="ri-bold"></i>
                          </a>
  
                          <a href="javascript:void(0)" class="font-18 text-dark" (click)="applyFormat('italic')">
                            <i class="ri-italic"></i>
                          </a>
  
                          <a href="javascript:void(0)" class="font-18 text-dark" (click)="applyFormat('underline')">
                            <i class="ri-underline"></i>
                          </a>                        
                        </div>
                      }
                    </div>
                  }
  
                  <div 
                    class="icon-container d-flex align-items-center w-100" 
                     [ngClass]="{
                      'is-recording': isRecording,
                      'col-12 px-5': attachment && contentType?.includes('audio/'),
                      'position-static': attachment && contentType?.includes('audio/')
                    }"
                  >
                    @if(isLoading || (attachment && contentType?.includes('audio/'))) {
                      <div class="w-100">
                      
                        @if(isLoading && !attachment) {
                          <div class="d-flex flex-column align-items-center position-absolute ms-5 mt-5">
                            <mat-spinner [diameter]="25" [color]="'primary'" mode="indeterminate" />
                            <small class="mx-auto text-muted">{{ 'attendance.chatSchedule.loadingAudio' | translate }}</small>
                          </div>
                        }
                        
                        @if(attachment && contentType?.includes('audio/')) {
                          <div class="is-recorded">
                            <audio [src]="attachment" controls></audio>
                            <a href="javascript:void(0)" class="text-danger" (click)="cancelPreview(data.attendance._id); removeAttachment()">
                              <i class="ri-delete-bin-6-line font-22"></i>
                            </a>
                          </div>
                        }
                      </div>
                    }
                  
                    @if(!audioUrl && !isRecording && !isLoading && !contentType?.includes('audio/') && data.attendance?.channel?.type !== 'RCS_API') {
                      <a
                        href="javascript:void(0)"
                        class="text-dark"
                        (click)="toggleRecording(data.attendance._id)"
                      >
                        <i class="mdi mdi-microphone font-22"></i>
                      </a>
                    }
  
                    @if(isRecording) {
                      <div class="d-flex align-items-center justify-content-center gap-4">
                        <a href="javascript:void(0)" class="text-danger" (click)="toggleRecording(data.attendance._id)">
                          <i class="ri-stop-circle-line font-22"></i>
                        </a>
                        <p class="m-0">{{ getFormattedTime() }}</p>
                        <a href="javascript:void(0)" class="text-danger" (click)="cancelRecording()">
                          <i class="ri-delete-bin-6-line font-22"></i>
                        </a>
                      </div>
                    }
                  </div>
                </div>
  
                <div class="col-5 mt-2">
  
                  @if(loadingSpinner$ | async) {
                    <loading-component />
                  }
                
                  @if (!(loadingSpinner$ | async)) {}
                  <ng-container>
                    @if((!attachment || !attachment.trim()) || contentType === 'text') {
                      <ng-container>
                        <label for="dropzone-file" class="w-100">
                          <div class="upload-area">
                            <div class="placeholder-content">
                              <i class="mdi mdi-cloud-upload-outline upload-icon text-primary"></i>
                              <p class="text-primary">{{ 'attendance.chatSchedule.clickToUpload' | translate }}</p>
                              <p class="text-muted">{{ 'attendance.chatSchedule.uploadFormats' | translate }}</p>
                            </div>
                            <input type="file" accept="image/jpg, image/jpeg, image/png, application/pdf">
                          </div>
                        </label>
                      </ng-container>
                    }
                    
                    @if(attachment && contentType?.includes('image/')) {
                      <div class="upload-area upload-area--schedule-message">
                        <img 
                          class="rounded d-block mw-100"  
                          [src]="attachment" 
                          alt="Uploaded image"
                        />
                      </div>
                    }
  
                    @if(attachment && contentType?.includes('video/')) {
                      <video
                        class="rounded w-100 h-100"
                        [src]="attachment"
                        controls>
                        {{ 'attendance.chatSchedule.browserVideoPlaybackNotSupported' | translate }}
                      </video>
                    }
                    
                    @if(attachment && contentType?.includes('application/pdf')) {
                      <div class="d-flex align-items-center justify-content-center">
                        <i class="ri-file-text-line"></i>
                        <p>{{ 'attendance.chatSchedule.documentLoaded' | translate }}</p>
                      </div>
                    }
  
                    <div class="w-100 d-flex justify-content-center">
                      @if(
                        attachment && attachment.trim() && (contentType?.includes('image/') || 
                        contentType?.includes('video/') || 
                        contentType?.includes('application/pdf'))
                      ) {
                        <a href="javascript:void(0)" (click)="removeAttachment()">
                          <i class="ri-delete-bin-5-line text-danger font-22"></i>
                        </a>
                      }
                    </div>
                    
                    @if(!attachment && !contentType?.includes('audio/')) {
                      <input
                        id="dropzone-file"
                        type="file"
                        (change)="onMidiaChange($event)"
                        class="position-absolute opacity-0 pe-none top-0 right-0"
                      />
                    }
  
                  </ng-container>
                </div>
              </div>
            }

            @if (isTypeButton()) {
              <div>
                  <app-button-zapi-component 
                    [buttonActionsArray]="getButtonActionsFormArray()" 
                    [maxButtons]="3"
                    [showFullMessage]="true"
                    [title]="$safeNavigationMigration(form.get('title')?.value)"
                    [message]="$safeNavigationMigration(form.get('message')?.value)"
                    [footer]="$safeNavigationMigration(form.get('footer')?.value)"
                    (titleChange)="form.get('title').setValue($event)"
                    (messageChange)="form.get('message').setValue($event)"
                    (footerChange)="form.get('footer').setValue($event)">
                  </app-button-zapi-component>
              </div>
            }

            <field-error-component 
              [field]="'message'" 
              [label]="'Mensagem'" 
              [formGroup]="form"
            />
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button
          [mat-dialog-close]="true"
          class="btn btn-light"
          type="button"
        >
          {{ 'attendance.chatSchedule.cancel' | translate }}
        </button>
        <button
          class="btn btn-primary"
          type="button"
          [disabled]="(loadingSpinner$ | async) || isMessageValid() || !form.valid"
          (click)="saveMessageScheduled()"
        >
          {{ 'attendance.chatSchedule.save' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

